<script>
    import { createEventDispatcher } from "svelte";

    export let oneLine = false;

    const dispatch = createEventDispatcher();
</script>

<div on:click={() => dispatch("click")} class="pCursor">
    {#if oneLine}
        <div class="ldiv">
            <div class="logo">Fondation <b class="logo2">Beyeler</b></div>
        </div>
    {:else}
        <div class="ldiv">
            <div class="logo">Fondation</div>
            <div class="logo2">Beyeler</div>
        </div>
    {/if}
</div>

<style>
    .ldiv {
        align-items: center;
        text-align: center;
        text-transform: uppercase;
        width: fit-content;
    }

    .logo {
        font-family: "Trade Gothic";
        font-weight: 400;
        font-size: 18px;
        letter-spacing: -1px;
        line-height: 1;
        color: var(--black-100);
    }

    .logo2 {
        font-family: "Trade Gothic LT Std";
        font-weight: 700;
        font-size: 18px;
        line-height: 1;
        color: var(--black-100);
    }
</style>
